const fetch = window.fetch;

export function getToken() {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
}
const systemId = window.systemId;
const formatPagination = (res) => {
  if (typeof res.pagination === "object") {
    res.pagination = {
      ...res.pagination,
      current: res.pagination.currentPage,
      pageSize: res.pagination.listRows,
      total: res.pagination.totalRows,
    };
  }
  return res;
};
const _hooks = {};
export const addRequestHook = (url, fn) => {
  _hooks[url] = fn;
};
export const getRequestHook = (url) => {
  return _hooks[url];
};
const _reqHooks = {};
export const addRequestHookBefore = (url, fn) => {
  _reqHooks[url] = fn;
};
export const getRequestHookBefore = (url) => {
  return _reqHooks[url];
};
const _resHooks = {};
export const addRequestHookAfter = (url, fn) => {
  _resHooks[url] = fn;
};
export const getRequestHookAfter = (url) => {
  return _resHooks[url];
};
export default function request(url, params, ...rest) {
  const defaultOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      Authorization: `${getToken()}`,
    },
  };
  const requestBefore = getRequestHookBefore(url);
  const requestAfter = getRequestHookAfter(url);
  const body = requestBefore ? requestBefore(params) : params;
  const newOptions = { ...defaultOptions, body };
  if (!(body instanceof FormData)) {
    newOptions.headers = {
      ...newOptions.headers,
      "Content-Type": "application/json; charset=utf-8",
    };
    newOptions.body = JSON.stringify({
      ...newOptions.body,
      systemId: window.systemId,
    });
  }
  let hok = getRequestHook(url);
  if (hok) {
    return hok(body, ...rest);
  }
  return fetch(url, newOptions)
    .then((res) => res.json())
    .then((res) => {
      if (res.status) {
        if (res.status === 1003) {
          try {
            window.$$app._store.dispatch({
              type: "login/reLogin",
            });
          } catch (e) {
            console.log(e);
            throw res;
          }
        } else {
          throw res;
        }
      }
      return requestAfter
        ? requestAfter(formatPagination(res))
        : formatPagination(res);
    });
}

export function syncRequest(url, body) {
  //同步请求
  const params = body || {};
  return new Promise((resolve, reject) => {
    const oAjax = new XMLHttpRequest();
    oAjax.open("POST", url, false); //false同步请求  （true异步）
    oAjax.setRequestHeader("Content-type", "application/json; charset=utf-8");
    oAjax.setRequestHeader("Authorization", getToken());
    oAjax.onreadystatechange = function () {
      if (oAjax.readyState === 4 && oAjax.status === 200) {
        console.log(oAjax);
        resolve(JSON.parse(oAjax.responseText));
      } else {
        console.log(oAjax);
      }
    };
    oAjax.send(
      JSON.stringify({
        ...params,
        systemId: systemId,
      })
    );
  });
}
